import React, { useState } from "react";
import { useTable } from "react-table";
import * as XLSX from "xlsx";
import db from "./Firebase";
import { collection, query, where, getDocs, doc, updateDoc } from "firebase/firestore";
import Swal from "sweetalert2";

const ExcelUpload = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [phoneNumbers, setPhoneNumbers] = useState([]);
    const [courseName, setCourseName] = useState("");
    const [day, setDay] = useState("");

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const parsedData = XLSX.utils.sheet_to_json(sheet);

            setData(parsedData);

            // Ensure all phone numbers are stored as strings
            const extractedPhones = parsedData.map((item) => item.phone.toString()).filter(Boolean);
            setPhoneNumbers(extractedPhones);

            if (parsedData.length > 0) {
                setCourseName(parsedData[0]["course name"] || "");
                setDay(parsedData[0]["day"] || "");
            }
        };

        reader.readAsBinaryString(file);
    };

    const updateLessonTimes = async () => {
        setLoading(true);
        try {
            if (phoneNumbers.length === 0 || !courseName) {
                Swal.fire("Error", "Missing required data from uploaded file!", "error");
                setLoading(false);
                return;
            }

            let updatedCount = 0;
            const updatePromises = [];

            console.log("Starting Update Process...");
            console.log("Course Name:", courseName);
            console.log("Phone Numbers:", phoneNumbers);

            for (const phone of phoneNumbers) {
                console.log(`🔍 Querying Firestore for phone: ${phone}`);

                const q = query(
                    collection(db, "nv_enrolled_courses"),
                    where("course_name", "==", courseName), // Ensure this exists in Firestore
                    where("phone_no", "==", phone.toString()) // Convert to string
                );

                const querySnapshot = await getDocs(q);

                console.log("Query Snapshot:", querySnapshot);
                console.log("Number of Docs Found:", querySnapshot.docs.length);

                if (querySnapshot.empty) {
                    console.warn(`⚠️ No documents found for phone: ${phone}`);
                    continue;
                }

                for (const courseDoc of querySnapshot.docs) {
                    const courseRef = doc(db, "nv_enrolled_courses", courseDoc.id);
                    const courseData = courseDoc.data();
                    console.log(phone)

                    console.log("✅ Found document:", courseDoc.id, "Data:", courseData);
                    console.log("🔍 Checking if phone exists in Excel data...");
                    console.log("Excel Data:", data);

                    const excelEntry = data.find((item) => item.phone.toString() === phone.toString());

                    console.log("Matching Excel Entry:", excelEntry);

                    if (!excelEntry) {
                        console.warn(`⚠️ No matching Excel entry for phone: ${phone}`);
                        continue;
                    }

                    console.log("Extracted Day:", day);


                    const updatedLessons = courseData.lessons.map((lesson, index) =>
                        index === parseInt(day - 1) ? { ...lesson, completion_percentage: "100%", is_completed: "yes", } : lesson
                    );

                    console.log("Updated Lessons Array:", updatedLessons);
                    console.log("Updating Firestore Document:", courseDoc.id);

                    updatePromises.push(updateDoc(courseRef, { lessons: updatedLessons }));
                    updatedCount++;
                }

            }

            await Promise.all(updatePromises);
            setLoading(false);
            Swal.fire("Success", `Updated lesson times for ${updatedCount} users!`, "success");
        } catch (error) {
            console.error("❌ Error updating lesson times:", error);
            setLoading(false);
            Swal.fire("Error", "Failed to update lesson times!", "error");
        }
    };

    const columns = React.useMemo(
        () => [
            { Header: "Course Name", accessor: "course name" },
            { Header: "Phone No", accessor: "phone" },
            { Header: "Day", accessor: "day" },
            { Header: "Video Id", accessor: "video id" },
        ],
        []
    );

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });

    return (
        <div className="p-6 max-w-3xl mx-auto">
            <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} className="mb-4" />
            <button onClick={updateLessonTimes} className="px-4 py-2 bg-blue-500 text-white rounded" disabled={loading}>
                {loading ? "Updating..." : "Update Enrolled Course Data"}
            </button>
            <div className="border border-gray-200 p-4 rounded-lg shadow-sm mt-4">
                <table {...getTableProps()} className="w-full border border-gray-200">
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()} className="bg-gray-100">
                                {headerGroup.headers.map((column) => (
                                    <th {...column.getHeaderProps()} className="border p-2">
                                        {column.render("Header")}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {rows.map((row) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()} className="border">
                                    {row.cells.map((cell) => (
                                        <td {...cell.getCellProps()} className="border p-2">
                                            {cell.render("Cell")}
                                        </td>
                                    ))}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ExcelUpload;



// import React, { useState } from "react";
// import { useTable } from "react-table";
// import * as XLSX from "xlsx";
// import db from "./Firebase";
// import { collection, query, where, getDocs, doc, updateDoc } from "firebase/firestore";
// import Swal from "sweetalert2";

// const ExcelUpload = () => {
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [phoneNumbers, setPhoneNumbers] = useState([]);
//     const [courseName, setCourseName] = useState("");
//     const [videoId, setVideoId] = useState("");
//     const [day, setDay] = useState("");

//     const handleFileUpload = (e) => {
//         const file = e.target.files[0];
//         const reader = new FileReader();

//         reader.onload = (event) => {
//             const binaryStr = event.target.result;
//             const workbook = XLSX.read(binaryStr, { type: "binary" });
//             const sheetName = workbook.SheetNames[0];
//             const sheet = workbook.Sheets[sheetName];
//             const parsedData = XLSX.utils.sheet_to_json(sheet);
//             setData(parsedData);

//             // Extract phone numbers and course name from uploaded data
//             const extractedPhones = parsedData.map((item) => item.phone).filter(Boolean);
//             setPhoneNumbers(extractedPhones);

//             if (parsedData.length > 0) {
//                 setCourseName(parsedData[0]["course name"] || "");
//                 setVideoId(parsedData[0]["video id"] || "");
//                 setDay(parsedData[0]["day"] || "");
//             }
//         };

//         reader.readAsBinaryString(file);
//     };

//     const updateLessonTimes = async () => {
//         setLoading(true);
//         try {
//             if (phoneNumbers.length === 0 || !courseName) {
//                 Swal.fire("Error", "Missing required data from uploaded file!", "error");
//                 setLoading(false);
//                 return;
//             }

//             const q = query(
//                 collection(db, "nv_enrolled_courses"),
//                 where("course_name", "==", courseName),
//                 where("phone_no", "in", ["8171461502"])
//             );

//             console.log(courseName)
//             console.log(phoneNumbers)

//             const querySnapshot = await getDocs(q);

//             if (querySnapshot.empty) {
//                 Swal.fire("Error", "No matching enrolled users found!", "error");
//                 setLoading(false);
//                 return;
//             }

//             let updatedCount = 0;
//             for (const courseDoc of querySnapshot.docs) {
//                 const courseRef = doc(db, "nv_enrolled_courses", courseDoc.id);
//                 const courseData = courseDoc.data();

//                 const updatedLessons = courseData.lessons.map((lesson, index) =>
//                     index === parseInt(day - 1) ? { ...lesson, completion_percentage: "100%", video_link: videoId } : lesson
//                 );



//                 await updateDoc(courseRef, { lessons: updatedLessons });
//                 updatedCount++;
//             }

//             setLoading(false);
//             Swal.fire("Success", `Updated lesson times for ${updatedCount} users!`, "success");
//         } catch (error) {
//             console.error("Error updating lesson times:", error);
//             setLoading(false);
//             Swal.fire("Error", "Failed to update lesson times!", "error");
//         }
//     };

//     const columns = React.useMemo(
//         () => [
//             { Header: "Course Name", accessor: "course name" },
//             { Header: "Phone No", accessor: "phone" },
//             { Header: "Day", accessor: "day" },
//             { Header: "Video Id", accessor: "video id" },
//         ],
//         []
//     );

//     const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
//         useTable({ columns, data });

//     return (
//         <div className="p-6 max-w-3xl mx-auto">
//             <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} className="mb-4" />
//             <button onClick={updateLessonTimes} className="px-4 py-2 bg-blue-500 text-white rounded" disabled={loading}>
//                 {loading ? "Updating..." : "Update Enrolled Course Data"}
//             </button>
//             <div className="border border-gray-200 p-4 rounded-lg shadow-sm mt-4">
//                 <table {...getTableProps()} className="w-full border border-gray-200">
//                     <thead>
//                         {headerGroups.map((headerGroup) => (
//                             <tr {...headerGroup.getHeaderGroupProps()} className="bg-gray-100">
//                                 {headerGroup.headers.map((column) => (
//                                     <th {...column.getHeaderProps()} className="border p-2">
//                                         {column.render("Header")}
//                                     </th>
//                                 ))}
//                             </tr>
//                         ))}
//                     </thead>
//                     <tbody {...getTableBodyProps()}>
//                         {rows.map((row) => {
//                             prepareRow(row);
//                             return (
//                                 <tr {...row.getRowProps()} className="border">
//                                     {row.cells.map((cell) => (
//                                         <td {...cell.getCellProps()} className="border p-2">
//                                             {cell.render("Cell")}
//                                         </td>
//                                     ))}
//                                 </tr>
//                             );
//                         })}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };

// export default ExcelUpload;


// // import React, { useState } from "react";
// // import { useTable } from "react-table";
// // import * as XLSX from "xlsx";

// // const ExcelUpload = () => {
// //     const [data, setData] = useState([]);

// //     const handleFileUpload = (e) => {
// //         const file = e.target.files[0];
// //         const reader = new FileReader();

// //         reader.onload = (event) => {
// //             const binaryStr = event.target.result;
// //             const workbook = XLSX.read(binaryStr, { type: "binary" });
// //             const sheetName = workbook.SheetNames[0];
// //             const sheet = workbook.Sheets[sheetName];
// //             const parsedData = XLSX.utils.sheet_to_json(sheet);
// //             setData(parsedData);
// //         };

// //         reader.readAsBinaryString(file);
// //     };

// //     const columns = React.useMemo(
// //         () => [
// //             { Header: "Course Name", accessor: "course name" },
// //             { Header: "Phone No", accessor: "phone" },
// //             { Header: "Day", accessor: "day" },
// //             { Header: "Video Id", accessor: "video id" },
// //         ],
// //         []
// //     );

// //     const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
// //         useTable({ columns, data });

// //     return (
// //         <div className="p-6 max-w-3xl mx-auto">
// //             <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} className="mb-4" />
// //             <div className="border border-gray-200 p-4 rounded-lg shadow-sm">
// //                 <table {...getTableProps()} className="w-full border border-gray-200 mt-4">
// //                     <thead>
// //                         {headerGroups.map((headerGroup) => (
// //                             <tr {...headerGroup.getHeaderGroupProps()} className="bg-gray-100">
// //                                 {headerGroup.headers.map((column) => (
// //                                     <th {...column.getHeaderProps()} className="border p-2">
// //                                         {column.render("Header")}
// //                                     </th>
// //                                 ))}
// //                             </tr>
// //                         ))}
// //                     </thead>
// //                     <tbody {...getTableBodyProps()}>
// //                         {rows.map((row) => {
// //                             prepareRow(row);
// //                             return (
// //                                 <tr {...row.getRowProps()} className="border">
// //                                     {row.cells.map((cell) => (
// //                                         <td {...cell.getCellProps()} className="border p-2">
// //                                             {cell.render("Cell")}
// //                                         </td>
// //                                     ))}
// //                                 </tr>
// //                             );
// //                         })}
// //                     </tbody>
// //                 </table>
// //             </div>
// //         </div>
// //     );
// // };

// // export default ExcelUpload;